import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import BlackOverlay from '../../partials/black_overlay';
import BackgroundImage from '../../partials/background_image';
import Footer from '../footer';
import NavBar from '../navbar';
import { generateRandomId } from '../../../helpers';
import { Animated } from "react-animated-css";
import Contact from '../contact';
import Logo from '../logo';
import Burger from '../burger';
import config from '../../../config';

import "animate.css/animate.min.css";

// August 6th: refactored for responsiveness
class Two extends React.Component {
    state = {
        navBarTransparent: false,
        menuOpen: false,
        medal: null,
        bootstrapped: false
    }
    componentWillMount() {
        this.setState({ medal: this.props.medal });
    }
    componentDidMount = () => { window.scrollTo(0, 0); }
    componentWillReceiveProps = (nextProps) => {
        if (this.state.medal !== nextProps.medal) {
            this.setState({ medal: nextProps.medal, bootstrapped: true });
        }
    }
    onEnterViewport = () => this.setState({ navBarTransparent: true });
    onExitViewport = () => this.setState({ navBarTransparent: false });
    onToggleMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

    render() {
        const { navBarTransparent, menuOpen, medal } = this.state, { nbs, title, bi, hero = 600 } = this.props;

        return <section>
            {/* Navbar */}
            <div className={`w3-top nav-bar  ${navBarTransparent ? 'nav-bar-transparent' : 'w3-card'}`}>
                <Contact />
                <div className={`w3-bar d-flex flex-row  w3-content font-11`} style={{ height: 70 }}>
                    <Logo className={`${(medal) ? 'hide-768' : ''}`} medal={medal} />
                    <NavBar nbs={nbs} />
                    <a className="w3-button w3-padding-large ml-auto w3-hide-medium w3-hide-large flex-row justify-content-center burger bg-black" onClick={this.onToggleMenu} title="Toggle Navigation Menu">
                        <i className="fa fa-bars white align-self-center font-20" />
                    </a>
                </div>
            </div>
            <div className={`w3-sidebar w3-bar-block w3-card w3-animate-right w3-center bg-black white ${menuOpen ? '' : 'w3-hide'}`}
                style={{ right: 0, width: '90%', zIndex: 4 }}>
                <Burger onToggleMenu={this.onToggleMenu} />
            </div>
            <div className="bg-blackish">
                <div style={{ height: hero, position: 'relative' }}>
                    <BackgroundImage key={generateRandomId(5)} bi={bi} />
                    {bi && <BlackOverlay />}
                    <div className="h-100 w-100 d-flex flex-column justify-content-center">
                        <Animated animationIn="fadeInLeft" className="">
                            <h1 className="hero-text anton text-center w-100">{title}</h1>
                        </Animated>
                    </div>
                    {/* In case of a medal, we hide the logo and show up the medal here */}
                    {medal && medal.id && <section className="floating-medal">
                        <Animated animateOnMount={false} animationIn="fadeInLeft" className="d-flex flex-column h-100">
                            <img alt="" src={medal.Medal || `${config.apiEndpoint}/api/cs/v2/medals/image/decode/${medal.id}.png`} style={{ maxHeight: 140 }} />
                            <span className="white anton font-14 toUpper align-self-center">{medal.Name}</span>
                        </Animated>
                    </section>}
                </div>
                <ScrollTrigger onEnter={this.onEnterViewport} onExit={this.onExitViewport} throttleScroll={0}
                    triggerOnLoad={true} style={{ position: 'absolute', top: 150, height: 50 }} className="w-100" />
                {React.cloneElement(this.props.children, this.props)}
            </div>
            <div style={{ height: 48 }} />
            <footer className={`w3-container p-2 w3-black show`}>
                <Footer />
            </footer>
        </section>
    }
}

export default Two;


// WEBPACK FOOTER //
// ./src/components/layouts/two/index.js